import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {Object} FrontPageVideoRef
 * @property {HTMLVideoElement} video
 */

/**
 * @typedef {Object} FrontPageVideoInterface
 * @property {FrontPageVideoRef} $refs
 */

/**
 * Homepage class.
 */
export default class FrontPageVideo extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'FrontPageVideo',
    refs: ['video'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {FrontPageVideo & FrontPageVideoInterface}
   */
  mounted() {
    if (this.$refs.video.readyState === 4) {
      this.$el.classList.add('loaded');
    } else {
      this.$refs.video.addEventListener('loadeddata', () => {
        this.$el.classList.add('loaded');
      });
    }
  }

  /**
   * Unbind all events on destroy.
   *
   * @this {FrontPageVideo & FrontPageVideoInterface}
   * @return {FrontPageVideo} The FrontPageVideo instance.
   */
  destroyed() {
    return this;
  }
}
